import { useEffect, useState } from "react";
import { HomeHeader } from "@/components/home/HomeHeader";
import { Pricing } from "@/components/home/Pricing";
import { Faq } from "@/components/home/Faq";
import { CtaBand, HomeFooter } from "@/components/home/HomeFooter";
import { CompanySignupDialog } from "@/components/home/CompanySignupDialog";
import { LandingHero } from "@/components/landing/LandingHero";
import { LandingProblem, LandingSteps, LandingFeatures, LandingRelated } from "@/components/landing/LandingSections";
import { SEO, useSeo } from "@/seo/useSeo";
import { useTrackVisit } from "@/lib/track";
import { useGoogleTag } from "@/lib/gtag";

// Keyword landing pages (/time-sheet-app, /payroll-app, /proof-of-job); content lives in seo/pages.json.
export default function Landing({ path }) {
  const page = SEO.pages[path];
  const [signup, setSignup] = useState(false);
  const start = () => setSignup(true);
  useSeo(path);
  useTrackVisit(path);
  useGoogleTag(path);
  useEffect(() => window.scrollTo(0, 0), [path]);
  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#0F172A] text-left" data-testid={`landing-${page.slug}`}>
      <HomeHeader onStart={start} />
      <main>
        <LandingHero page={page} onStart={start} />
        <LandingProblem page={page} />
        <LandingSteps page={page} />
        <LandingFeatures page={page} />
        <Pricing onStart={start} num="04" />
        <Faq items={page.faqs} num="05" title={page.faqTitle} />
        <LandingRelated page={page} />
        <CtaBand onStart={start} />
      </main>
      <HomeFooter />
      <CompanySignupDialog open={signup} onOpenChange={setSignup} />
    </div>
  );
}
